/* eslint-disable no-unused-vars */
import React from 'react';
import { CustomPinnedRowRenderer } from './CustomPinnedRowRenderer';

const emptySections = ['bid', 'budget', 'countries', 'action'];
const sectionsWithRightBorder = ['bid', 'budget'];

export const CellRendererSelector = (params) => {
  const showRightBorder = sectionsWithRightBorder.includes(params.colDef.colId);

  if (params.node.rowPinned) {
    if (params.colDef.colId === 'campaign') {
      return {
        component: () => (
          <p
            style={{
              marginLeft: '40px',
              height: '100%',
              lineHeight: '48px',
              color: '#64748B',
              fontSize: '12px',
              fontWeight: '400',
              textAlign: 'left',
            }}
          >
            Total:
          </p>
        ),
      };
    }
    if (emptySections.includes(params.colDef.colId)) {
      return {
        component: () => (
          <div
            style={{
              borderRight: showRightBorder ? '1px solid #E2E8F0' : '',
              height: '48px',
              width: '100%',
            }}
          ></div>
        ),
      };
    } else {
      return {
        component: CustomPinnedRowRenderer,
        params: {
          field: params.colDef.field,
        },
      };
    }
  } else {
    return undefined;
  }
};
